// ProductMoreInfo.jsx
import React from "react";

export default function ProductMoreInfo({ isMobile }) {
  return (
    <div>
      {/* TABS */}
      <div
        style={{
          display: "flex",
          gap: isMobile ? "10px" : "15px",
          marginTop: "40px",
          flexWrap: "wrap",
          justifyContent: isMobile ? "center" : "flex-start",
        }}
      >
        <button style={activeTab}>Description</button>
        {/* <button style={tab}>Reviews</button>
        <button style={tab}>Resources</button> */}
      </div>

      {/* FULL DESCRIPTION */}
      <p style={{ marginTop: "20px" }}>
       Banana Powder is a fine, light-coloured powder made from ripe bananas that are peeled, sliced, dried, and ground. It retains much 
of the original banana flavour, aroma, and nutritional properties, making it a popular ingredient in food and health industries.


      </p>

      <h3>Key Features:</h3>
      <ul>
        <li>Source: Made from high-quality bananas, the most commonly consumed banana variety globally.</li>
        <li>Colour & Texture: Pale yellow to light cream colour, fine powder texture.</li>
        <li>Flavour: Sweet, natural banana flavour and aroma.</li>
        <li>Shelf Life: Long shelf life due to low moisture content.</li>
      </ul>

      <h3>Nutritional Benefits:</h3>
      <ul>
        <li>Rich in potassium, vitamin B6, vitamin C, and dietary fibre.</li>
        <li>Contains natural sugars like fructose, glucose, and sucrose for quick energy.</li>
        <li>Low in fat and free from artificial additives.</li>
      </ul>  

      <h3>Applications:</h3>
      <ul>
      <li>Food & Beverage: Used in smoothies, baby food, bakery items (cakes, muffins, pancakes), dairy products (yogurt, milkshakes), ice cream, and 
breakfast cereals.</li>
      <li>Nutraceuticals: Incorporated into protein powders and health supplements.</li>
      <li>Cosmetics: Used in natural face masks and skincare formulations for its moisturising and antioxidant properties.</li>
      <li>Pharmaceuticals: Acts as a binding agent or flavouring in tablets and syrups.</li>
      </ul>

      <h3>Advantages:</h3>
      <ul>
        <li>Easy to store and transport compared to fresh bananas.</li>
        <li>Consistent quality and taste for industrial use.</li>
        <li>Instant rehydration with water or milk for various applications.</li>
      </ul>
    </div>
  );
}

const activeTab = {
  padding: "10px 20px",
  background: "green",
  color: "white",
  borderRadius: "8px",
  border: "none",
};

const tab = {
  padding: "10px 20px",
  borderRadius: "8px",
  border: "1px solid #ccc",
};
